import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ASM_FEATURE } from '@asm/const';
import { StoreModule } from '@ngrx/store';
import { StateModule } from '@spartacus/core';
import { metaReducers, reducerProvider, reducerToken } from './reducers';

@NgModule({
  imports: [CommonModule, StateModule, StoreModule.forFeature(ASM_FEATURE, reducerToken, { metaReducers })],
  providers: [reducerProvider],
})
export class AsmStoreModule {}
